import React, { useMemo, useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label, FormGroup, Button, CardTitle, Modal, ModalHeader, ModalBody, Table, CardHeader, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import Breadcrumb from '../Common/Breadcrumb';
import TableContainer from '../Common/TableContainer';
import Select from 'react-select'
import axios from '../../axios';
import moment from 'moment';
import SweetAlert from "react-bootstrap-sweetalert"
import { Link } from "react-router-dom"
import Numeral from 'react-numeral';
import FileSaver from 'file-saver'
import Xl from 'excel4node'
import { useHistory } from 'react-router-dom'
import ShippedOrder from "./ShippedOrder";
import MonthWiseBooking from "./MonthWiseBooking";
import "./testing.css"
import { FaTruckFast } from 'react-icons/fa';
import SimpleBar from "simplebar-react";

import backgroundImage from "../../../src/assets/images/BACKFINAL.png"


function Testing() {

    useEffect(() => {
        recentactivity()

    }, [])

    const [dbdata, setdbdata] = useState([])

    const history = useHistory()
    const dashboard = () => {
        history.push("/dashboard")
    }
    const BookedOrder = () => {
        history.push("/bookorder")
    }
    const ShippedOrder = () => {
        history.push("/shippedorder")
    }
    const MonthWiseBooking = () => {
        history.push("/monthwisebooking")
    }
    const Timeaction = () => {
        history.push("/timeandaction")
    }
    const IpoNo = () => {
        history.push("/postatus")
    }
    const orderrecon = () => {
        history.push("/OrderReconcillation")
    }
    const booking_ship = () => {
        history.push("/BookingaAndShipment")
    }
    const delayship = () => {
        history.push("/DelayShipment")
    }



    const recentactivity = async () => {
        await axios.instance.get(`/RecentActivity?companyid=1`)
            .then((res) => {
                console.log(res.data, "recentactivity")
                setdbdata(res.data)

            })

    }

    return (
        <React.Fragment>
            <div className="account-pages my-5 pt-5 m-3 pt-sm-5 " id="flow">
                <Container fluid={true} style={{
                    backgroundColor: "#11244c", color: "#11244c",
                    background: `url(${backgroundImage})`, backgroundSize: "auto",
                    backgroundRepeat: 'no-repeat'
                }} >
                    <Row>
                        <Col lg={4}>
                            <Card>
                                <Row>
                                    <Col>

                                        <CardBody  >
                                            <div className="float-end">
                                                <UncontrolledDropdown>
                                                    <DropdownToggle tag="a" className="text-reset" id="dropdownMenuButton5" caret>
                                                        <span className="text-muted">Recent<i className="mdi mdi-chevron-down ms-1"></i></span>
                                                    </DropdownToggle>
                                                    <DropdownMenu className="dropdown-menu-end">
                                                        <DropdownItem href="#">Recent</DropdownItem>
                                                        <DropdownItem href="#">By Users</DropdownItem>
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </div>
                                            <h4 className="card-title mb-4" style={{ color: "#11244c" }}><b></b>Recent Activity</h4>

                                            <SimpleBar className="activity-feed mb-0 ps-2" style={{ maxHeight: '563px' }}>
                                                {dbdata.map((data, index) =>
                                                    <li className="feed-item" key={index}>
                                                        <div className="feed-item-list">
                                                            <p className="text-muted mb-1 font-size-13"><small className="d-inline-block ms-1">{moment(data.DATE).format("DD-MM-YYYY")}</small></p>
                                                            <p className="mt-0 mb-0">Order For <span>{data.qty}</span> <span>{data.Garment}</span> Under Order Number : <span style={{ color: "#11244c", fontWeight: "bold" }}>{data.OrderNo}</span> & Ipo No : <span style={{ color: "#11244c", fontWeight: "bold" }}>{data.Ipono}</span> <span>{data.descr}</span><span style={{ color: "#11244c", fontWeight: "bold" }}>{data.buyer}</span>
                                                            </p>
                                                        </div>
                                                    </li>)}


                                            </SimpleBar>
                                        </CardBody>
                                    </Col>
                                </Row>

                            </Card>
                        </Col>
                        <Col lg={8}>
                            <Card  >
                                <CardBody style={{
                                    backgroundColor: "#11244c", color: "#11244c",
                                    background: `url(${backgroundImage})`, backgroundSize: "auto",
                                    backgroundRepeat: 'no-repeat',
                                }}>
                                    <Row>
                                        <Col xs='12' sm='6' md='4' lg='4'>
                                            <Card className="demo1" style={{ borderRadius: "24px", cursor: "pointer", border: "solid" }} onClick={() => dashboard()}>
                                                <CardBody className="demo" style={{ borderRadius: "20px" }}>
                                                    <div className="demo">
                                                        <div className="d-flex justify-content-center">
                                                            <i className="mdi mdi-desktop-mac-dashboard" style={{ fontSize: '60px' }}></i>
                                                            {/* <FaTruckFast /> */}

                                                            {/* <img  src="./Dashboard hower.png" ></img> */}
                                                        </div>
                                                        <div className="d-flex justify-content-center">
                                                            <p style={{ fontSize: '20px', fontWeight: 'bold' }}  >Dashboard</p>
                                                        </div>
                                                    </div>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                        <Col xs='12' sm='6' md='4' lg='4'>
                                            <Card className="demo1" style={{ borderRadius: "24px", cursor: "pointer", border: "solid" }} onClick={() => { BookedOrder() }}>
                                                <CardBody className="demo" style={{ borderRadius: "20px" }}>
                                                    <div className="demo">
                                                        <div className="d-flex justify-content-center">
                                                            <i className="bx bxs-shopping-bag" style={{ fontSize: '90px' }}></i>
                                                            {/* <img style={{height:'130px',width:'130px',}} src="./Dashboard hower.png"></img> */}
                                                        </div>
                                                        <div className="d-flex justify-content-center">
                                                            <p style={{ fontSize: '20px', cursor: "pointer", fontWeight: 'bold' }}  >Booked Order</p>
                                                        </div>
                                                    </div>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                        <Col xs='12' sm='6' md='4' lg='4'>
                                            <Card className="demo1" style={{ borderRadius: "24px", cursor: "pointer", border: "solid" }} onClick={() => ShippedOrder()}>
                                                <CardBody className="demo" style={{ borderRadius: "20px" }}>
                                                    <div className="demo">
                                                        <div className="d-flex justify-content-center">
                                                            <i className="mdi mdi-truck-fast-outline" style={{ fontSize: '60px' }}></i>
                                                            {/* <img style={{height:'130px',width:'130px',}} src="./Dashboard hower.png"></img> */}
                                                        </div>
                                                        <div className="d-flex justify-content-center">
                                                            <p style={{ fontSize: '20px', cursor: "pointer", fontWeight: 'bold' }}  >Shipped Order</p>
                                                        </div>
                                                    </div>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                        <Col xs='12' sm='6' md='4' lg='4'>
                                            <Card className="demo1" style={{ borderRadius: "24px", cursor: "pointer", border: "solid" }} onClick={() => MonthWiseBooking()}>
                                                <CardBody className="demo" style={{ borderRadius: "20px" }}>
                                                    <div className="demo">
                                                        <div className="d-flex justify-content-center">
                                                            <i className="uil uil-chart-line" style={{ fontSize: '60px' }}></i>
                                                            {/* <img style={{height:'130px',width:'130px',}} src="./Dashboard hower.png"></img> */}
                                                        </div>
                                                        <div className="d-flex justify-content-center text-nowrap">
                                                            <p style={{ fontSize: '20px', cursor: "pointer", fontWeight: 'bold' }}  >Month Wise Booking</p>
                                                        </div>
                                                    </div>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                        <Col xs='12' sm='6' md='4' lg='4'>
                                            <Card className="demo1" style={{ borderRadius: "24px", cursor: "pointer", border: "solid" }} onClick={() => IpoNo()}>
                                                <CardBody className="demo" style={{ borderRadius: "20px" }}>
                                                    <div className="demo">
                                                        <div className="d-flex justify-content-center">
                                                            <i className="uil uil-file-check-alt" style={{ fontSize: '60px' }}></i>
                                                            {/* 
                                                    <img style={{height:'130px',width:'130px',}} src="./Dashboard hower.png"></img> */}
                                                        </div>
                                                        <div className="d-flex justify-content-center text-nowrap">
                                                            <p style={{ fontSize: '20px', cursor: "pointer", fontWeight: 'bold' }}  >IPO Wise PO Status</p>
                                                        </div>
                                                    </div>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                        <Col xs='12' sm='6' md='4' lg='4'>
                                            <Card className="demo1" style={{ borderRadius: "24px", cursor: "pointer", border: "solid" }} onClick={() => Timeaction()}>
                                                <CardBody className="demo" style={{ borderRadius: "20px" }}>
                                                    <div className="demo">
                                                        <div className="d-flex justify-content-center">
                                                            <i className="mdi mdi-clipboard-list-outline" style={{ fontSize: '60px' }}></i>

                                                            {/* <img style={{height:'130px',width:'130px',}} src="./Dashboard hower.png"></img> */}
                                                        </div>
                                                        <div className="d-flex justify-content-center text-nowrap">
                                                            <p style={{ fontSize: '20px', cursor: "pointer", fontWeight: 'bold' }}  >T&A Status Tracking</p>
                                                        </div>
                                                    </div>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                        <Col xs='12' sm='6' md='4' lg='4'>
                                            <Card className="demo1" style={{ borderRadius: "24px", cursor: "pointer", border: "solid" }} onClick={() => orderrecon()}>
                                                <CardBody className="demo" style={{ borderRadius: "20px" }}>
                                                    <div className="demo">
                                                        <div className="d-flex justify-content-center">
                                                            <i className="mdi mdi-clipboard-flow-outline" style={{ fontSize: '60px' }}></i>

                                                            {/* <img style={{height:'130px',width:'130px',}} src="./Dashboard hower.png"></img> */}
                                                        </div>
                                                        <div className="d-flex justify-content-center text-nowrap">
                                                            <p style={{ fontSize: '20px', cursor: "pointer", fontWeight: 'bold' }}  >Order Reconcillation</p>
                                                        </div>
                                                    </div>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                        <Col xs='12' sm='6' md='4' lg='4'>
                                            <Card className="demo1" style={{ borderRadius: "24px", cursor: "pointer", border: "solid" }} onClick={() => booking_ship()}>
                                                <CardBody className="demo" style={{ borderRadius: "20px" }}>
                                                    <div className="demo">
                                                        <div className="d-flex justify-content-center">
                                                            <i className="mdi mdi-clipboard-file" style={{ fontSize: '60px' }}></i>

                                                            {/* <img style={{height:'130px',width:'130px',}} src="./Dashboard hower.png"></img> */}
                                                        </div>
                                                        <div className="d-flex justify-content-center text-nowrap">
                                                            <p style={{ fontSize: '20px', cursor: "pointer", fontWeight: 'bold' }}  >Booking & Shipment</p>
                                                        </div>
                                                    </div>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                        <Col xs='12' sm='6' md='4' lg='4'>
                                            <Card className="demo1" style={{ borderRadius: "24px", cursor: "pointer", border: "solid" }} onClick={() => delayship()}>
                                                <CardBody className="demo" style={{ borderRadius: "20px" }}>
                                                    <div className="demo">
                                                        <div className="d-flex justify-content-center">
                                                            <i className="mdi mdi-truck" style={{ fontSize: '60px' }}></i>

                                                            {/* <img style={{height:'130px',width:'130px',}} src="./Dashboard hower.png"></img> */}
                                                        </div>
                                                        <div className="d-flex justify-content-center text-nowrap">
                                                            <p style={{ fontSize: '20px', cursor: "pointer", fontWeight: 'bold' }}  >Delay Shipment</p>
                                                        </div>
                                                    </div>

                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Testing